import React from 'react'
import PropTypes from 'prop-types'
import { DisplayAttorneyActivities } from 'components/DueDiligence/Questions'

import styles from './styles'

function BuildAttorneyActivitiesInfo(props) {
  const { activities } = props
  const questionData = {
    items: activities,
  }

  const classes = styles()

  return (
    <div className={classes.root}>
      <DisplayAttorneyActivities questionData={questionData} />
    </div>
  )
}

BuildAttorneyActivitiesInfo.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      cpf: PropTypes.string,
      name: PropTypes.string,
      degree_of_kinship: PropTypes.string,
      attachments: PropTypes.arrayOf(
        PropTypes.shape({
          document_url: PropTypes.string,
          file_name: PropTypes.string,
          uuid: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
}

export default BuildAttorneyActivitiesInfo
